import React from 'react';
import { Platforms as PlatformsComponent } from '@adjust/dashboard-components';
import { hasWebAttributionPackage } from '@adjust/dashboard-core/lib/utils/account';
import { Account } from '@adjust/dashboard-core/api/types';

import { Platforms as AppPlatforms } from '@api/types';
import { connectWithStore } from '@common/connectWithStore';
import { getCurrentAccount } from '@redux/ducks/global';

interface PlatformsProps {
  account: Nullable<Account>;
  platforms: AppPlatforms;
  attributionPlatform: string;
  hideUnconfigured?: boolean;
}

const Platforms: React.FC<PlatformsProps> = ({ account, platforms, attributionPlatform, hideUnconfigured = false }) => (
  <PlatformsComponent
    platforms={platforms}
    attributionPlatform={attributionPlatform}
    hasWebAttributionPackage={hasWebAttributionPackage(account)}
    hideUnconfigured={hideUnconfigured}
  />
);

const mapStateToProps = state => ({
  account: getCurrentAccount(state),
});

export default connectWithStore(mapStateToProps)(Platforms);
